export enum LikeType {
	PRODUCT = "PRODUCT",
	POST = "POST",
	MICROBLOGPOST = "MICRO BLOG POST",
	EVENT = "EVENT",
	COMMENT = "COMMENT",
	REVIEW = "REVIEW"
}
